let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6HBYC")).then(() => parcelRequire('l59oX'));